import { render, staticRenderFns } from "./DialogoDeReimpressao.vue?vue&type=template&id=8effc68e&scoped=true&"
import script from "./DialogoDeReimpressao.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeReimpressao.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoDeReimpressao.vue?vue&type=style&index=0&id=8effc68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8effc68e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBottomSheet,VBtn,VCard,VCardTitle,VIcon,VSimpleTable})
